module.exports = __webpack_public_path__ + "img/traegheit.dbda4632.png";